import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import CreateIcon from '@mui/icons-material/Create';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

export const BannerInfoContratos = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        mt: 3,
        p: { xs: 3, md: 4 },
        backgroundColor: '#F8F7FA',
        borderRadius: 3,
        border: '1px solid #EAEAFF',
        mb: 3,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}>
        <Box sx={{ p: 1, borderRadius: '50%', backgroundColor: '#E8E7FD', display: 'flex', mr: 2 }}>
          <DescriptionOutlinedIcon sx={{ color: '#696CFF', fontSize: 32 }} />
        </Box>
        <Box>
          <Typography
            variant="h6"
            sx={{ color: '#696CFF', fontWeight: 700, mb: 0.5, fontSize: '1.15rem' }}
          >
            ¿Qué es la gestión de Contratos?
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontWeight: 500, maxWidth: '80%' }}
          >
            Desde este módulo puedes administrar las plantillas y formatos de contratos utilizados
            en la organización. Facilita la creación, edición y seguimiento de los diferentes tipos
            de acuerdos laborales.
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={3} sx={{ pl: { xs: 0, sm: 8.5 } }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <CreateIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
              Redacción Dinámica
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Utiliza nuestro editor integrado para crear y dar formato a los documentos legales y
              contractuales fácilmente.
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <FolderSharedIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
              Tipos de Contrato
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Clasifica los contratos según su modalidad (término fijo, indefinido, obra labor,
              etc.) para mantener el orden.
            </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <AssignmentTurnedInIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
              Gestión Activa
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Activa o desactiva las plantillas para garantizar que solo los documentos vigentes
              sean utilizados por tu equipo.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};
